import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("seq_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("seq_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth callback, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("seq_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const setSession = (token, u) => {
    localStorage.setItem("seq_token", token);
    setUser(u);
  };

  const enterAccount = async (tenantId, userId) => {
    const { data } = await api.post(`/admin/tenants/${tenantId}/impersonate`, userId ? { user_id: userId } : {});
    if (!localStorage.getItem("seq_admin_token")) localStorage.setItem("seq_admin_token", localStorage.getItem("seq_token"));
    localStorage.setItem("seq_token", data.token);
    const me = await api.get("/auth/me");
    setUser(me.data);
  };

  const exitAccount = async () => {
    const adminToken = localStorage.getItem("seq_admin_token");
    localStorage.removeItem("seq_admin_token");
    if (!adminToken) return logout();
    localStorage.setItem("seq_token", adminToken);
    const me = await api.get("/auth/me");
    setUser(me.data);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("seq_token");
    localStorage.removeItem("seq_admin_token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setSession, refresh: checkAuth, enterAccount, exitAccount }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
